import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, CircularProgress, Typography, TableContainer, Table, TableHead, TableRow,
  TableCell, TableBody, Paper, Chip, FormControl, Select, MenuItem,
} from '@mui/material';
import SearchBar from '../SearchBar';
import FilterPanel from '../FilterPanel';

const getStatusColor = (status) => {
  switch (status) {
    case 'active': return 'primary';
    case 'completed': return 'success';
    case 'cancelled': return 'error';
    default: return 'default';
  }
};

const AdminProjectTable = ({
  projects, loading, searchQuery, onSearch, filters, onFilterChange,
  homeownersList, onAssignHomeowner,
}) => {
  const navigate = useNavigate();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={8}>
        <CircularProgress />
      </Box>
    );
  }

  if (projects.length === 0) {
    return (
      <Box textAlign="center" py={8}>
        <Typography variant="h6" color="text.secondary">No projects in the system</Typography>
      </Box>
    );
  }

  return (
    <>
      <Box mb={3}>
        <SearchBar placeholder="Search projects..." onSearch={onSearch} defaultValue={searchQuery} />
      </Box>
      <Box mb={3}>
        <FilterPanel filters={filters} onFilterChange={onFilterChange} />
      </Box>
      <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell><strong>Project Name</strong></TableCell>
              <TableCell><strong>Contractor</strong></TableCell>
              <TableCell><strong>Homeowner</strong></TableCell>
              <TableCell><strong>Assign Homeowner</strong></TableCell>
              <TableCell><strong>Status</strong></TableCell>
              <TableCell><strong>Created</strong></TableCell>
              <TableCell><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {projects.map((project) => (
              <TableRow key={project.id} hover>
                <TableCell>{project.name}</TableCell>
                <TableCell>{project.contractor_first_name} {project.contractor_last_name}</TableCell>
                <TableCell>
                  {project.homeowner_first_name
                    ? `${project.homeowner_first_name} ${project.homeowner_last_name}`
                    : <Chip label="Not Assigned" size="small" color="warning" />}
                </TableCell>
                <TableCell>
                  <FormControl size="small" sx={{ minWidth: 200 }}>
                    <Select
                      value={project.homeowner_id || ''}
                      onChange={(e) => onAssignHomeowner(project.id, e.target.value)}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        {homeownersList.length === 0 ? 'No homeowners available' : 'Select homeowner...'}
                      </MenuItem>
                      {homeownersList.map((h) => (
                        <MenuItem key={h.id} value={h.id}>
                          {h.first_name} {h.last_name} ({h.email})
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell>
                  <Chip label={project.status} size="small" color={getStatusColor(project.status)} />
                </TableCell>
                <TableCell>{new Date(project.created_at).toLocaleDateString()}</TableCell>
                <TableCell>
                  <Chip
                    label="View Details"
                    size="small"
                    color="primary"
                    onClick={() => navigate(`/project/${project.id}`)}
                    sx={{ cursor: 'pointer' }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default AdminProjectTable;
